import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Layout from "../Layout";
import { useDispatch, useSelector } from 'react-redux';
import SocialLogins from "../OnBoard/Signup/SocailLogins";
import CreateAccount from "../OnBoard/Signup";
import CreatePassword from '../OnBoard/Signup/CreatePassword';
import PersonalInfo from "./Signup/PersonalInfo";
import PersonalInfoSummery from "./Signup/PersonalInfoSummery";
import FinalRegistrationThroughSSN from "./Signup/finalRegistrationThroughSSN";
import logFirebaseEvents from "../LogFirebaseEvents";
import { checkEmailExtension } from "../../helpers/utils/Utils";
import StudentSelection from "./Signup/StudentSelection";
import StudentEmailVerfication from "./Signup/StudentEmailVerfication";
import { StudentUniversity } from "./Signup/StudentUniversity";
import StudentAccessCode from "./Signup/StudentAccessCode";
import SmiOneExpirationDateAndLastDigitCard from "./Signup/SmiOneExpirationDateAndLastDigitCard";
import LocateMyCardDetails from "./Signup/LocateMyCardDetails";
import SmiOneRegistrationThroughSSN from "./Signup/SmiOneRegistrationThroughSSN";
import AgreementsAndDisclosures from "./Signup/AgreementsAndDisclosures/AgreementsAndDisclosures";
import { useTranslation } from 'react-i18next';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
export const OnBoard = () => {
  const [activeComponent, setActiveComponent] = useState(null);
  const [signUpEmail, setsignUpEmail] = useState('');
  const [isPartner, setisPartner] = useState('');
  const [signUpPassword, setPassword] = useState('');
  const [personalInfo, setpersonalInfo] = useState({});
  const providerIdentifier = useSelector(state => state.providerIdentifier);
  const smiOneId = useSelector(state => state.smiOneId);
  const provider = useSelector(state => state.provider);
  const isFromSmiOne = useSelector((state) => state.fromSmiOne);
  const location = useLocation();
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);  
  const { t } = useTranslation();
  useDocumentTitle(t('page_title_get_started'));
  // When returning from Kudzu+ T&C acceptance during signup, restore to finalRegistration step
  useEffect(() => {
    if (location.state?.acceptedTC) {
      setActiveComponent("finalRegistration");
    }
  }, [location]);
   

    
  useEffect(() => { 
    // Scroll to the top when the number of cards changes
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [activeComponent]); 
  
  const renderComponent = () => { 
    switch (activeComponent) {
      case "createAccount":
        return <CreateAccount 
          userEmail={signUpEmail}
          handleBackToSocialLogins={() => handleSocailSignupClick(null)}
          openCreatePasswordwithemail={createPasswordEmail} 
           onCreatePasswordClick={() => {
            debugger
            if (providerIdentifier != null && providerIdentifier != undefined && providerIdentifier != '') {
              handleSocailSignupClick("personal") 
            }  
          
      }} />;

      case "studentUserType":
         return <StudentSelection openYesImstudent={() => handleSocailSignupClick("studentEmail")} 
         openImNotStudent={() => {

           
          if (providerIdentifier != null && providerIdentifier != undefined && providerIdentifier != '') {
            handleSocailSignupClick("personal")
          } else{
            handleSocailSignupClick("createPassword"); 
          }
        
        }}/>;
      case "studentEmail":
         return <StudentEmailVerfication
           userEmail={signUpEmail}
           backtoUserType={() => handleSocailSignupClick("personal")} 
           openAccessCodewithemail={() => handleSocailSignupClick("studentAccessCode")} 
           openUniversitySelection={() => handleSocailSignupClick("universitySelection")}
           onStudentDetailsComplete={() => {
             // After student details, go to personalInfoSummary (not back to personal page)
             handleSocailSignupClick("personalInfoSummary");
           }}
         />;
      case "studentAccessCode":
      return <StudentAccessCode  handleBackOpenEmail={() => handleSocailSignupClick("studentEmail")} handleOpenCreatePassword={() =>{
        if (providerIdentifier != null && providerIdentifier != undefined && providerIdentifier != '') {
          handleSocailSignupClick("personal")
        } else{
          handleSocailSignupClick("createPassword"); 
        }
        }} />;  
      case 'universitySelection':
      return <StudentUniversity  backtoEmail={() => handleSocailSignupClick("studentEmail")} openCreatPassword={() => {
        if (providerIdentifier != null && providerIdentifier != undefined && providerIdentifier != '') {
          handleSocailSignupClick("personal")
        } else{
          handleSocailSignupClick("createPassword"); 
        }
      }}/>
      case "createPassword":
        // return <CreatePassword email={signUpEmail}  openCreatePassword={createPasswordForEmail} openPatriotActClick={() => handleSocailSignupClick("patriotAct")} />;
        return <CreatePassword email={signUpEmail}  openCreatePassword={createPasswordForEmail} openPersonalInformationClick={() => {isFromSmiOne ? handleSocailSignupClick("agreementsAndDisclosures") : handleSocailSignupClick("personal")}} />;
      case "smiOneExpirationDate":
        return <SmiOneExpirationDateAndLastDigitCard handleLastdigitNo ={() =>{handleSocailSignupClick("smiOneRegistrationThroughSSN")}}  locateMyCardDetails={() =>{handleSocailSignupClick("locateMyCardDetails")}} />;
      
        case "locateMyCardDetails":
        return <LocateMyCardDetails   gotItLocateMyCardDetails={() =>{handleSocailSignupClick("smiOneExpirationDate")}} />;

        case "smiOneRegistrationThroughSSN":
        return <SmiOneRegistrationThroughSSN  handleSmiOneSSN={() =>{handleSocailSignupClick("personalInfoSummary")}} />;
    
      case "personal":
        return <PersonalInfo backToStudenEmailVerification={() => {
          if (providerIdentifier != null && providerIdentifier != undefined && providerIdentifier != '') {
            handleSocailSignupClick("studentAccessCode")
          } else{
            handleSocailSignupClick("createPassword"); 
          }
        }}  email={signUpEmail} password={signUpPassword} openPersonalInfoSummaryClick={() => handleSocailSignupClick("personalInfoSummary")} getDataFromPersonalInfo={getDataFromPersonalInfo}  openTermsandConditionsonClick={() => handleSocailSignupClick("agreementsAndDisclosures")} handleOpenCreatePassword={() => handleSocailSignupClick("createPassword")} openStudentDetailsClick={() => handleSocailSignupClick("studentEmail")} />;

      case "personalInfoSummary":
        return <PersonalInfoSummery 
          personalInfo={personalInfo}  
          openPatriotActClick={() => isFromSmiOne? handleSocailSignupClick("createPassword") : handleSocailSignupClick("agreementsAndDisclosures")}
          backToPersonalInfo={() => handleSocailSignupClick("personal")}
        />
      case "finalRegistration":
        return <FinalRegistrationThroughSSN kudzuPlusTrue={kudzuPlusTrue} />
      case "agreementsAndDisclosures":
        return <AgreementsAndDisclosures handleContinueClick={() => handleSocailSignupClick("finalRegistration")} />
      default:
        return null ;

    }
  };


  const createPasswordEmail = (email,isPartnerUniversity) => {
    debugger;
    setsignUpEmail(email); 
    const isValidExtension = checkEmailExtension(email); 
    if (providerIdentifier != null && providerIdentifier != undefined && providerIdentifier != '' && isFromSmiOne) {
      handleSocailSignupClick("smiOneExpirationDate") 
    }  
   else if (isFromSmiOne) {
      handleSocailSignupClick("smiOneExpirationDate")
    }else{
      handleSocailSignupClick("createPassword");
  }
  };

  const CkeckPartnerOrNot = (isPartner) => {
    debugger
    setisPartner(isPartner);  
    if(isPartner){
      handleSocailSignupClick("createPassword");
    }else{
      handleSocailSignupClick("universitySelection"); 
    }  
  }

  const createPasswordForEmail = (password) => { 
    setPassword(password);
  };

  const getDataFromPersonalInfo = (personalData) => {
    setpersonalInfo(personalData);
    
  };
    const handleSocailSignupClick = (componentName) => {
    setActiveComponent(componentName);
  };



  return (

    <Layout>
      {!activeComponent && (
        <SocialLogins onSocailSignupClick={(email) =>{
          setsignUpEmail(email)
          handleSocailSignupClick("createAccount")
        }} 
          onSocialAuthClick={(email) => {
          handleSocailSignupClick("createPassword")
          setsignUpEmail(email);  
        }} 
        />
      )}
   
        {renderComponent()}

    </Layout>

  );
};

export default OnBoard;
